
import Tools from '@/tools/tools'

export default {
  async imprimir(pedido, http, store) {
    const janela = window.open('', '_blank')
    if (!janela) {
      Tools.exibirMensagem(store, 'Atenção', 'warning', 'Navegador bloqueou a abertura do relatório.')
      return
    }

    try {
      janela.document.write('<html><head><title>Gerando Espelho...</title><style>body{font-family:sans-serif;display:flex;justify-content:center;align-items:center;height:100vh;}</style></head><body><h3>Gerando espelho da expedição...</h3></body></html>')
      
      const response = await http.get(`/api/protected/terminal-expedicao-vendas/itens-pedido/${pedido.SEQUENCIA}`)
      const dados = response.data
      
      // Busca dados reais da empresa preferencial do sistema
      let empresa = { NOME: 'CECWEB', CNPJ: '', NOME_EMPRESA: '' }
      try {
        const respEmpresa = await http.get('/api/protected/conferenciaFinanceira/empresa-preferencial')
        if (respEmpresa.data) {
          const e = respEmpresa.data
          empresa = {
            NOME: e.FANTASIA || e.RAZAO_RELATORIO || e.RAZAO || 'CECWEB',
            CNPJ: e.CNPJ,
            NOME_EMPRESA: e.NOME_EMPRESA || ''
          }
        }
      } catch (errEmp) {
        console.error('Erro ao buscar empresa preferencial:', errEmp)
      }
      
      const html = this.montarHtml(pedido, dados, empresa)
      janela.document.open()
      janela.document.write(html)
      janela.document.close()
    } catch (err) {
      console.error(err)
      janela.close()
      Tools.exibirMensagem(store, 'Erro', 'danger', 'Erro ao gerar espelho da expedição')
    }
  },

  montarHtml(pedido, dados, empresa) {
    const dataHora = new Date().toLocaleString('pt-BR')
    const cliente = dados.venda?.NOME_CLIENTE || '—'
    const vendedor = dados.venda?.NOME_VENDEDOR || '—'
    
    let linhasResumo = ''
    let totalPesoConf = 0
    let totalPecasConf = 0
    let totalPesoPed = 0
    let totalPecasPed = 0

    dados.itens.forEach(i => {
      const pPed = Number(i.PECAS_PEDIDO || 0)
      const pConf = Number(i.PECAS_CONFERIDA || 0)
      const qPed = Number(i.QUANT_PEDIDO || 0)
      const qConf = Number(i.QUANT_CONFERIDA || 0)

      totalPecasPed += pPed
      totalPecasConf += pConf
      totalPesoPed += qPed
      totalPesoConf += qConf

      const diffPecas = pConf - pPed
      const diffPeso = qConf - qPed
      
      const classDiffPecas = diffPecas < 0 ? 'text-danger' : (diffPecas > 0 ? 'text-success' : '')
      const classDiffPeso = diffPeso < 0 ? 'text-danger' : (diffPeso > 0 ? 'text-success' : '')

      linhasResumo += `
        <tr>
          <td>${i.COD_PRO}</td>
          <td>${i.DESCRICAO}</td>
          <td style="text-align:center;">${pPed}</td>
          <td style="text-align:center;">${pConf}</td>
          <td style="text-align:center; font-weight:bold;" class="${classDiffPecas}">${diffPecas > 0 ? '+' : ''}${diffPecas}</td>
          <td style="text-align:right;">${qPed.toFixed(3)} kg</td>
          <td style="text-align:right;">${qConf.toFixed(3)} kg</td>
          <td style="text-align:right; font-weight:bold;" class="${classDiffPeso}">${diffPeso > 0 ? '+' : ''}${diffPeso.toFixed(3)} kg</td>
        </tr>
      `
    })

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Espelho de Expedição - #${pedido.SEQUENCIA}</title>
        <style>
          body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; margin: 0; padding: 40px; color: #333; font-size: 11px; }
          .header { display: flex; justify-content: space-between; border-bottom: 2px solid #333; padding-bottom: 10px; margin-bottom: 20px; }
          .header h1 { margin: 0; font-size: 18px; color: #2d3748; }
          .info-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 15px; margin-bottom: 20px; background: #f7fafc; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0; }
          .info-item label { display: block; font-weight: bold; color: #718096; text-transform: uppercase; font-size: 9px; margin-bottom: 2px; }
          .info-item span { font-size: 13px; font-weight: 600; }
          .kpi-row { display: flex; gap: 15px; margin-bottom: 20px; }
          .kpi-card { flex: 1; background: #fff; border: 1px solid #e2e8f0; padding: 12px; border-radius: 8px; text-align: center; }
          .kpi-card small { color: #718096; font-size: 9px; text-transform: uppercase; font-weight: bold; }
          .kpi-card div { font-size: 18px; font-weight: 800; color: #2d3748; margin-top: 4px; }
          h2 { font-size: 12px; text-transform: uppercase; border-left: 4px solid #4a5568; padding-left: 10px; margin: 25px 0 12px 0; color: #2d3748; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 20px; table-layout: fixed; }
          th { background: #edf2f7; text-align: left; padding: 8px; border-bottom: 2px solid #cbd5e0; text-transform: uppercase; font-size: 9px; color: #4a5568; }
          td { padding: 8px; border-bottom: 1px solid #e2e8f0; word-wrap: break-word; }
          .text-danger { color: #e53e3e; }
          .text-success { color: #38a169; }
          .footer { margin-top: 40px; text-align: center; font-size: 9px; color: #a0aec0; border-top: 1px solid #e2e8f0; padding-top: 10px; }
          @media print { body { padding: 10px; } .no-print { display: none; } }
        </style>
      </head>
      <body>
        <div class="header">
          <div>
            <div style="font-size: 20px; font-weight: 800; color: #1a365d; margin-bottom: 4px;">${empresa.NOME}</div>
            <h1>ESPELHO DE EXPEDIÇÃO / CONFERÊNCIA</h1>
            <div style="font-size: 10px; color: #718096; font-weight: 600;">${empresa.NOME_EMPRESA}</div>
          </div>
          <div style="text-align:right;">
            <div style="font-weight:bold;">Pedido #${pedido.SEQUENCIA}</div>
            <div>Gerado em: ${dataHora}</div>
          </div>
        </div>

        <div class="info-grid">
          <div class="info-item"><label>Cliente</label><span>${cliente}</span></div>
          <div class="info-item"><label>Vendedor</label><span>${vendedor}</span></div>
          <div class="info-item"><label>Data Saída</label><span>${pedido.DT_SAIDA ? new Date(pedido.DT_SAIDA).toLocaleDateString('pt-BR') : '—'}</span></div>
        </div>

        <div class="kpi-row">
          <div class="kpi-card"><small>Total Peças Pedido</small><div>${totalPecasPed}</div></div>
          <div class="kpi-card"><small>Peças Conferidas</small><div>${totalPecasConf}</div></div>
          <div class="kpi-card"><small>Peso Total Conferido</small><div>${totalPesoConf.toFixed(3)} kg</div></div>
        </div>

        <h2>Resumo por Produto</h2>
        <table>
          <thead>
            <tr>
              <th style="width:50px;">Cód.</th>
              <th>Produto</th>
              <th style="width:60px; text-align:center;">Ped. (V)</th>
              <th style="width:60px; text-align:center;">Conf. (V)</th>
              <th style="width:60px; text-align:center;">Dif. (V)</th>
              <th style="width:90px; text-align:right;">Peso Ped.</th>
              <th style="width:90px; text-align:right;">Peso Conf.</th>
              <th style="width:90px; text-align:right;">Dif. Peso</th>
            </tr>
          </thead>
          <tbody>${linhasResumo}</tbody>
        </table>

        <div class="footer">
          SISTEMA CECWEB - TERMINAL DE EXPEDIÇÃO
        </div>

        <script>window.onload = function() { window.print(); }<\/script>
      </body>
      </html>
    `
  }
}



// WEBPACK FOOTER //
// ./src/utils/reports/VendaExpedicaoReport.js